
export const spanToMinutes = (startMs: number, endMs: number): number => {
  return (endMs - startMs) / 1000 / 60;
}